import Vue from 'vue';
import Search from './Search.vue';
import {createStore} from './store';

const store = createStore({
	baseUrl: window.LOCALE ? `/${window.LOCALE}/` : '/',
	searchQuery: undefined,
	searchResult: undefined
});
new Vue({
	render: h => h(Search, {
		props: {
			searchInputPlaceholder: window.SEARCH_INPUT_PLACEHOLDER_LITERAL,
			searchResultFirst: window.SEARCH_RESULT_FIRST_LITERAL,
			searchResultSecond: window.SEARCH_RESULT_SECOND_LITERAL,
			searchResultThird: window.SEARCH_RESULT_THIRD_LITERAL
		}
	}),
	store
}).$mount('#header-main-search');	